export enum NavigationNodeEntryTypeEnum {
  LINK = 'CMSLinkComponent',
  MEDIA = 'CMSImageComponent',
  PUSH = 'PushCardComponent',
  NAVIGATION_BLOC = 'NavigationBlocModuleComponent'
}
